module.exports = __webpack_public_path__ + "html/explainer_66a63e7c065d17e348b5e6e0456d5292.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/explainer.html
// module id = v09R
// module chunks = 51